import { render } from "./icon-chevron-down.vue?vue&type=template&id=34579d33"
import script from "./icon-chevron-down.vue?vue&type=script&lang=js"
export * from "./icon-chevron-down.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__